export function sortPlayers(p1, p2) {
    if (p1.isGuest && p2.isGuest) {
        if (!p1.isGuest && p2.isGuest) {
            return -1;
        } else if (p1.isGuest && !p2.isGuest) {
            return 1;
        }
    }

    return p1.name > p2.name ? 1 : -1;
}